// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "ad_optimizer_suggestion".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "ad_optimizer_suggestion" table (1:1 with a DB row, on the wire). */
export const adOptimizerSuggestionAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    rule: z.string(),
    action: z.string(),
    subjectType: z.string(),
    subjectId: z.string(),
    metaCampaignId: z.string(),
    replacesAdId: z.string().nullable(),
    replacesMetaAdId: z.string().nullable(),
    sourceAdId: z.string(),
    serviceId: z.string(),
    offerId: z.string().nullable(),
    offerText: z.string().nullable(),
    reason: z.string(),
    graphicId: z.string().nullable(),
    draftAdId: z.string().nullable(),
    recommendationId: z.string().nullable(),
    status: z.string(),
    failureReason: z.string().nullable(),
    readyAt: z.string().datetime().nullable(),
    launchedAt: z.string().datetime().nullable(),
    completedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=adOptimizerSuggestion.js.map